import React from "react";
import { Slider } from "@/components/ui/slider";
import { useAppSelector, useAppDispatch } from "../store/hooks";
import { selectScale, setScale } from "../store/slices/configurationSlice";

const MIN = 0.25;
const MAX = 1.5;
const MARKS = [0.25, 0.5, 1, 1.5];

const percent = (value: number) => `${Math.round(value * 100)}%`;

export const ScaleSlider: React.FC<{ id?: string }> = ({ id }) => {
  const dispatch = useAppDispatch();
  const scale = useAppSelector(selectScale);

  return (
    <div className="grid gap-2">
      <Slider
        id={id}
        aria-label="Schaal"
        aria-valuetext={percent(scale)}
        step={0.05}
        min={MIN}
        max={MAX}
        value={[scale]}
        onValueChange={([value]) => dispatch(setScale(value))}
      />
      <div className="relative h-4 text-xs text-muted-foreground tabular-nums" aria-hidden="true">
        {MARKS.map((mark, i) => (
          <button
            key={mark}
            type="button"
            tabIndex={-1}
            onClick={() => dispatch(setScale(mark))}
            className="absolute hover:text-foreground"
            style={{
              left: `${((mark - MIN) / (MAX - MIN)) * 100}%`,
              transform:
                i === 0
                  ? "none"
                  : i === MARKS.length - 1
                    ? "translateX(-100%)"
                    : "translateX(-50%)",
            }}
          >
            {percent(mark)}
          </button>
        ))}
      </div>
    </div>
  );
};

export const formatScale = percent;
